module.exports = __webpack_public_path__ + "static/media/kid9.6972fa3f.png";